/**
 * Nom affiché d'une organisation (ORG-8, amendée le 2026-10-14).
 *
 * L'espace personnel s'affiche toujours « Mon espace », traduit selon la langue de l'interface :
 * son nom stocké est une valeur fixe, jamais le nom du compte, et il n'est pas renommable. Toute
 * autre organisation garde son nom tel quel. Seule source du libellé côté client — ne pas relire
 * `organization.name` pour un titre ou une liste.
 * @param {{ kind?: string, name?: string } | null | undefined} organization
 * @param {(key: string) => string} t
 * @returns {string}
 */
export function nomEspace(organization, t) {
  if (organization?.kind === 'personnel') return t('space.personal');
  return organization?.name ?? '';
}
